import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// vant
import 'vant/lib/index.css'
// axios
import axios from 'axios'

const app = createApp(App)

app.provide('$axios', axios)
app.use(store).use(router).mount('#app')
